












































































import { Vue, Component } from 'vue-property-decorator';
import NewsList from './components/NewsList.vue';
import { Tab, Tabs } from 'vant';
import CommentList from './components/CommentList.vue';
import CommentInput from './components/CommentInput.vue';
import { autoOpenApp } from '@/common/ts/common';
import { appShare, wxShareInfo } from '@/common/ts/common';
Vue.use(Tab).use(Tabs);
@Component({
  components: {  NewsList,
                CommentList,
                CommentInput } })
export default class Home extends Vue {
  active = 0;
  threshold: number = 6;
  banner: string = '';
  onChange(index: number) {
    this.active = index;
    localStorage.setItem('index', this.active.toString());
  }
  created() {
    this.active = localStorage.index;
    this.banner = './img/banner.jpg';
    // 分享
    appShare({
      title: '前进，中国！',
      url: window.location.href,
      subtitle: '前进，中国！',
      classId: -1,
      id: -1,
      image: 'https://image2.cqcb.com/d/file/topics/activity/2019-09-26/1569472789145banner.jpg',
      type: 3,
    });
    wxShareInfo({
      title: '前进，中国！',
      subtitle: '前进，中国！',
      image: 'https://image2.cqcb.com/d/file/topics/activity/2019-09-26/1569472789145banner.jpg',
    });
  }
}
